'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'music';
var width = 512;
var height = 512;
var aliases = [127925];
var unicode = 'f001';
var svgPathData = 'M434.8 16.5l-224 49.8c-11 2.4-18.8 12.2-18.8 23.4l0 84.4 272-60.4 0-73.7c0-15.4-14.2-26.8-29.2-23.4zM464 291.8l0-161.8-272 60.4 0 209.6c0 44.2-43 80-96 80s-96-35.8-96-80 43-80 96-80c33.4 0 62.8 14.2 80 35.8l0-266.1c0-18.7 13-35 31.3-39L431.3 .8c25-5.6 48.7 13.5 48.7 39L480 336c0 44.2-43 80-96 80s-96-35.8-96-80 43-80 96-80c33.4 0 62.8 14.2 80 35.8zm0 44.2c0-35.3-35.8-64-80-64s-80 28.7-80 64 35.8 64 80 64 80-28.7 80-64l0 0zM176 400c0-35.3-35.8-64-80-64s-80 28.7-80 64 35.8 64 80 64 80-28.7 80-64l0 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMusic = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;